import { useEffect, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack, TextField, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'store';
import { closeDialog } from 'store/slices/confirmDialog';
// ===============================|| UI DIALOG - FORMS ||=============================== //

export default function ConfirmDialog() {
    const theme = useTheme();
    const dispatch = useDispatch();

    // Accessing dialog data from Redux store
    const { open, title, callback, description, button, inputLabel, inputType } = useSelector((state: any) => state.confirmDialog);
    const [textFieldValue, setTextFieldValue] = useState('');
    const handleClose = (status: number) => {
        if (callback) {
            callback({
                status,
                str: textFieldValue
            });
        }
        dispatch(closeDialog());  
    };
    useEffect(() => {
        setTextFieldValue("");
    }, [open])

    return (
        <div>
            <Dialog open={open} onClose={() => handleClose(0)} aria-labelledby="form-dialog-title">
                {open && (
                    <>
                        <DialogTitle id="form-dialog-title">{title}</DialogTitle>
                        <DialogContent>
                            <Stack spacing={3}>
                                {description && description}
                                {inputLabel && (
                                    <TextField
                                        autoFocus size="small"
                                        label={inputLabel}
                                        type={inputType}
                                        fullWidth
                                        value={textFieldValue}
                                        onChange={(e) => {
                                            setTextFieldValue(e?.target?.value || "");
                                        }}
                                    />
                                )}
                            </Stack>
                        </DialogContent>
                        <DialogActions sx={{ pr: 2.5 }}>
                            {button?.cancel && (
                                <Button sx={{ color: theme.palette.error.dark }} onClick={() => handleClose(0)} color="secondary">
                                    {button?.cancel?.text || "Cancel"}
                                </Button>
                            )}
                            {button?.submit && (
                                <Button variant="contained" color='warning' size="small" onClick={() => handleClose(1)}>
                                    {button?.submit?.text || "Submit"}
                                </Button>
                            )}
                        </DialogActions>
                    </>
                )}
            </Dialog>
        </div>
    );
}
